<template>
  <div>
    <mdb-card v-if="roundStatus == 'Ready for Timer'">
      <mdb-card-header class="secondary-color"><h4>Ready?</h4></mdb-card-header>
      <mdb-card-body>
        <div v-if="currentState.iAmModerator">
          <p>Hit <b>Start</b> below when you and the other players are ready to begin the round.</p>
          <mdb-btn icon="clock" @click="$emit('setStatus', 'Timer Running')">Start</mdb-btn>
        </div>
        <div v-if="!game.iAmModerator">
          <span class="spinner-grow text-warning"/>
          <span class="text-warning">Waiting on {{ currentState.moderatorName }} to start the round.</span>
        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Time Up'">
      <mdb-card-header v-if="timeLeft <= 0" class="secondary-color"><h4>Time's Up!</h4></mdb-card-header>
      <div>
        <span class="spinner-grow text-warning"/>
        <span v-if="!currentState.iAmModerator" class="text-warning"> Waiting on {{ currentState.moderatorName }} to
          evaluate answers.</span>
      </div>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Timer Running'" class="mb-2">
      <mdb-card-header v-if="timeLeft > 0" class="primary-color text-white"><h4>⌚ Timer Running!</h4>
      </mdb-card-header>

      <mdb-card-body>
        <div v-if="timeLeft > 0 ">
          <mdb-progress :value="progressValue"/>
          <div class="text-info small">
            Write as many words for each category
            <span class="danger">starting with the letter {{ currentState.letter }} </span> as you can
            think of.
          </div>
          <div class="text-danger">
            All Words Must Start With
          </div>
          <div class="default-color-dark text-white h1 p-2" style="width:50%; margin: auto;">
            {{ currentState.letter.toUpperCase() }}
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Timer Running'">

      <!--<mdb-card>
        <mdb-card-body class="primary-color-dark text-white p-4 text-center">
          <div class="selected-letter">
            {{ currentState.letter }}
          </div>
        </mdb-card-body>
      </mdb-card> -->
      <mdb-card-body class="text-left">
        <div v-for="(c,i) in currentState.categories" :key="i">
          <div class="h4">{{ c }}</div>
          <cust-chip-input prompt="Press enter after each answer" :id="'chip-input-'+ i" :chips="myAnswers[i]"/>
        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentState.iAmModerator &&  roundStatus == 'Time Up'"
              class="mt-4">
      <mdb-card-body>
        <h4>Ready to Evaluate Round?</h4>
        <div class="text-info">
          Make sure everyone's timer is up first.
        </div>
        <div>

          <mdb-btn color="success" icon="check" @click="$emit('setStatus', 'Evaluate Round')">Evaluate!</mdb-btn>

        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentState.currentStatus == 'Evaluate Round'" class="mt-4 text-left">
      <mdb-card-body>
        <h4>Round Evaluation</h4>
        <div class="text-info" v-if="currentState.iAmModerator">
          <p>Read the answers provided. As the round moderator, you can toggle an answer's validity by
            tapping/clicking it. Players will only get points for the green answers.</p>
          <p>We already identified invalid answers -- either duplicates from multiple players or the word did not start
            with the right letter. However, you may need invalidate more subtle similarities (singular/plural, etc.)</p>
          <p>When you're done, click "Score Round" below.</p>
        </div>
        <div v-if="!currentState.iAmModerator">
          <span class="spinner-grow text-warning"/>
          <span class="text-warning"> {{ currentState.moderatorName }} should be
            reviewing answers now.</span>
        </div>

        <mdb-card v-for="(cat,i) in currentState.categories" :key="i">
          <mdb-card-header class="primary-color-dark text-white">
            <h3>{{ cat }}</h3>
          </mdb-card-header>
          <mdb-card-body v-if="playersLocal">
            <div v-for="p in playersLocal" :key="p.id">
              <div class="text-info h4">{{ p.name }}</div>
              <mdb-badge v-if="p.currentAnswer[i].length == 0" color="warning">None</mdb-badge>
              <a v-for="(ans,j) in p.currentAnswer[i] " v-if="p.currentAnswer && p.currentAnswer.length>0"
                 href="" @click.prevent="toggleValid(ans)">
                <mdb-chip text="white"
                          :color="ans.valid ? 'success-color' : 'danger-color'">
                  {{ ans.answer }}
                </mdb-chip>
              </a>
            </div>
          </mdb-card-body>
        </mdb-card>
        <mdb-btn v-if="currentState.iAmModerator" color="success" icon="check" @click="scoreRound">Score Round</mdb-btn>

      </mdb-card-body>
    </mdb-card>

    <scoreboard v-if="currentState.currentStatus == 'Review Scores'"
                :currentState="currentState" :game="game"/>

  </div>
</template>
<script>
import Avatar from "../common/Avatar";
import {
  mdbBadge,
  mdbBtn,
  mdbBtnFixed,
  mdbBtnFixedItem,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbProgress,
  mdbRow,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import WordCards from "./WordCards";
import WordCard from "./WordCard";
import moment from 'moment'
import Scoreboard from "./Scoreboard";
import {custChipInput} from "../common/CustChipInput";
import api from "../../services/groupsPlaceApi";

export default {
  name: "campfire-tutti-frutti-play",
  components: {

    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbChip,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalTitle,
    mdbChipInput,
    mdbMask,
    mdbBadge,
    mdbSpinner,
    mdbJumbotron,
    mdbBtnFixed,
    mdbBtnFixedItem,
    mdbProgress,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Avatar,
    WordCards,
    WordCard,
    Scoreboard,
    custChipInput
  },
  watch: {
    roundStatus(n, o) {
      if (n == "Timer Running") {
        this.myAnswers = [[], [], [], [], [], []]
        this.monitorTime()
      }
      if (n == "Evaluate Round") {
        this.fetchPlayers()
      }
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    currentUser() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
    lastError() {
      if (!this.game) return null
      else return this.game.lastError
    },
    roundStatus() {
      return this.currentState.currentStatus
    },
    players() {
      return this.currentState.players
    }
  },
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      progressValue: 0,
      timeLeft: 10,
      myAnswers: null,
      playersLocal: null
    }
  },
  mounted() {
    if (this.roundStatus == "Timer Running") this.monitorTime()
    if (this.roundStatus == "Evaluate Round") {
      this.prepareAnswers(this.currentState.players)
    }
  },
  methods: {
    toggleValid(ans) {
      if (!this.currentState.iAmModerator) return
      ans.valid = !ans.valid
    },
    monitorTime() {
      if (this.roundStatus != "Timer Running") return
      this.timeLeft = (moment(this.currentState.timeUp)).diff(moment()) / 1000
      if (this.timeLeft <= 0) this.progressValue = 100
      else {
        this.progressValue = Math.round((this.timeLeft / 120) * 100)
      }
      if (this.timeLeft > 0) {
        setTimeout(() => {
          this.monitorTime()
        }, 500)
      } else {
        this.currentState.currentStatus = "Time Up"
        this.submitAnswers()
      }
    },
    scoreRound() {
      let scores = []
      for (let p of this.playersLocal) {
        let row = {player: p.playerId, score: 0}
        for (let a1 of p.currentAnswer) {
          for (let a2 of a1) {
            if (a2.valid) row.score++
          }
        }
        scores.push(row)
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/submittedScore/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        scores: scores
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    submitAnswers() {
      if (!this.myAnswers || this.myAnswers.length == 0) return
      let answers = []
      for (let aSet of this.myAnswers) {
        let curr = []
        for (let ans of aSet) {
          curr.push(ans)
        }
        answers.push(curr)
      }

      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/answer/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        answer: answers
      }).then(
        (results) => {
          this.myAnswer = null
          this.currentState.iAnswered = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    fetchPlayers() {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/players/" + this.game.sessionId, {
        accessToken: this.game.accessToken
      }).then(
        (results) => {
          this.prepareAnswers(results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    prepareAnswers(players) {
      this.playersLocal = []
      let letter = this.currentState.letter[0].toLowerCase()
      for (let p of players) {
        let pl = JSON.parse(JSON.stringify(p))
        let a = JSON.parse(p.currentAnswer)
        pl.currentAnswer = []
        for (let ansSet of a) {
          let newSet = []
          for (let ans of ansSet) {
            let newAnswer = {answer: ans, valid: true}
            if (ans.toLowerCase()[0] != letter) newAnswer.valid = false
            newSet.push(newAnswer)
          }
          pl.currentAnswer.push(newSet)
        }
        this.playersLocal.push(pl)
      }
      for (let p of this.playersLocal) {
        for (let i = 0; i < p.currentAnswer.length; i++) {
          let answerSet = p.currentAnswer[i]
          for (let ans of answerSet) {
            if (ans.valid) {
              if (this.findDuplicate(ans.answer, i, p.playerId)) ans.valid = false
            }
          }
        }
      }

    },
    findDuplicate(answer, index, ignore) {
      let ret = false
      for (let p of this.playersLocal) {
        if (ignore != p.playerId) {
          let answerSet = p.currentAnswer[index]
          for (let a of answerSet) {
            if (a.answer && a.answer.toLowerCase() == answer.toLowerCase()) ret = true
          }
        }
      }
      return ret
    }
  }
};
</script>
